import Button from "~/components/_deprecated/forms/button";
import { useI18n } from "~/hooks/use-i18n";

import { Modal, ModalBody, ModalFooter, ModalHeader } from "../../../components/_deprecated/modal";
import { Flex, Text } from "../../../components/_deprecated/primitives";

interface IInterruptCreateOrEditActionModalProps {
  onConfirm: () => void;
  handleExit: () => void;
}

export const InterruptCreateOrEditActionModal = ({
  onConfirm,
  handleExit,
}: IInterruptCreateOrEditActionModalProps) => {
  const { t } = useI18n("scheduling");

  return (
    <Modal handleExit={handleExit}>
      <ModalHeader>
        <Text p="0.25rem">{t("scheduling:agenda.interrupt_action_modal.heading")}</Text>
      </ModalHeader>
      <ModalBody>
        <Text>{t("scheduling:agenda.interrupt_action_modal.body")}</Text>
      </ModalBody>
      <ModalFooter>
        <Flex justifyContent="flex-end">
          <Button variant="default" onClick={handleExit}>
            {t("scheduling:agenda.interrupt_action_modal.cancel")}
          </Button>
          <Button ml="2" variant="primary" onClick={onConfirm}>
            {t("scheduling:agenda.interrupt_action_modal.submit")}
          </Button>
        </Flex>
      </ModalFooter>
    </Modal>
  );
};
